import React from 'react';

import { useTranslations } from 'next-intl';

import WalletIcon from '@/assets/icons/wallet-white.svg';
import { P } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { formatNumberWithCommas } from '@/lib/utils/formatNumberWithCommas';

interface I_SwapOutputProps {
  value: string;
  balance?: string;
  tokenIcon: React.ReactNode;
  tokenLabel: string;
  placeholder?: string;
  showBalance?: boolean;
  onTokenButtonClick?: () => void;
  isImporting?: boolean;
  disabled?: boolean;
}

export function SwapOutput({
  value,
  balance,
  tokenIcon,
  tokenLabel,
  placeholder = '0,00',
  showBalance = false,
  onTokenButtonClick,
  isImporting = false,
  disabled = false
}: I_SwapOutputProps) {
  const t = useTranslations('pools');

  return (
    <div className="bg-accordion-brand p-5 rounded-lg">
      <div className="flex justify-between items-start">
        <div className="flex-1 grid gap-3.5">
          <Input
            value={value}
            readOnly
            placeholder={placeholder}
            className="w-40 outline-none border-0 ring-0! shadow-none p-0 text-foreground text-2xl! leading-loose bg-transparent cursor-default"
          />
          {showBalance && balance && (
            <P
              icon={<WalletIcon className="w-5 h-5 text-foreground" />}
              className="flex items-center text-foreground text-sm font-semibold"
            >
              {t('balance')}: {formatNumberWithCommas(balance)}
            </P>
          )}
        </div>
        <div className="flex flex-col items-end gap-3.5">
          <Button
            variant="secondary"
            className="flex justify-center items-center gap-2 text-center"
            onClick={onTokenButtonClick}
            disabled={disabled || isImporting}
          >
            {tokenIcon}
            {tokenLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
